import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import Prescription$1 from './Prescription.js';
import { useLensBundle } from '../../LensBundles/context.js';

const PrescriptionContainer = (props)=>{
    const { isContactLensStockEnabled  } = useFeatureToggles();
    const { attributes: { actions  } ,  } = useLensBundle();
    // Use void function to scope logic to only lens bundle enabled products
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    const handleLensBundleChange = props.hasSubscriptions ? actions.setAttribute : ()=>{};
    // Preliminary sorting of selected packSize
    const products = React__default.useMemo(()=>props.products.filter((product)=>product.attributes.packageQuantity === props.packSize
        )
    , [
        props.products,
        props.packSize
    ]);
    return /*#__PURE__*/ React__default.createElement(Prescription$1, swcHelpers.extends({}, props, {
        isStockEnabled: isContactLensStockEnabled,
        products: products,
        handleLensBundleChange: handleLensBundleChange
    }));
};
var Prescription = PrescriptionContainer;

export { Prescription as default };
//# sourceMappingURL=PrescriptionContainer.js.map
